import React from 'react';
import {Modal,
ModalHeader,
ModalBody} from 'reactstrap'
import getLogoBranding from "../../../../utils/getLogoBranding.js"


class modalPlan extends React.Component {
	constructor(props){
    super(props)
		this.state ={
			
		}
	}

	render() {
		return(
			<Modal isOpen={this.props.ModalState} toggle={() => this.props.CloseModal()} className="modal-lg">
				<ModalHeader toggle={() => this.props.CloseModal()}>View Payment History</ModalHeader>
				<ModalBody>
					<div id="inventory-invoice">
				    <div className="toolbar hidden-print">
			        <div className="text-right">
		            <button id="printInvoice" className="btn btn-info"><i className="fa fa-print"></i> Print</button>
		            <button className="btn btn-info"><i className="fa fa-file-pdf-o"></i> Export as PDF</button>
			        </div>
			        <hr/>
				    </div>
				    <div className="invoice overflow-auto">
			        <div style={{minWidth: '600px'}}>
		            <header>
	                <div className="row">
                    <div className="col">
                      <a target="_blank" href="javascript.void(0)">
                        <img
					                src={getLogoBranding("report", null)}
					                alt="Report Logo"/>
                      </a>
                    </div>
                    <div className="col company-details">
                      <h5 className="name">
                        <a href="" target="_blank" rel="noopener noreferrer">
                        	Asset Vaults. Ltd
                        </a>
                      </h5>
                      <div>Christchurch Central</div>
                      <div>(027) 4881 667</div>
                      <div>contact@assetvault.co.nz</div>
                    </div>
	                </div>
		            </header>
		            <main>
	                <div className="row contacts">
                    <div className="col invoice-to">
                      <div className="text-gray-light">INVOICE TO:</div>
                      <h5 className="to">You</h5>
                      <div className="address">B-56 Bulding Name, City, State - Indonesia</div>
                      <div className="email"><a href="mailto:test@example.com">test@example.com</a></div>
                    </div>
                    <div className="col invoice-details">
                      <h4 className="invoice-id">INVOICE 121</h4>
                      <div className="date">Date of Invoice: 28/11/2018</div>
                      <div className="date">Due Date: 28/11/2018</div>
                    </div>
	                </div>
	                <table cellSpacing="0" cellPadding="0">
                    <thead>
                      <tr>
                        <th>SR NO.</th>
                        <th className="text-left">DESCRIPTION</th>
                        <th className="text-right">PRICE</th>
                        <th className="text-right">TAX (10%)</th>
                        <th className="text-right">TOTAL</th>
                    	</tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="no">01</td>
                        <td className="text-left"><h3>Level 1 Plan</h3>Testing Description 1</td>
                        <td className="unit">$ 4.95</td>
                        <td className="tax">10%</td>
                        <td className="total">$ 5.445</td>
                      </tr>
                      <tr>
                        <td className="no">02</td>
                        <td className="text-left"><h3>Extra Plan</h3>Testing Description 2</td>
                        <td className="unit">$ 2.00</td>
                        <td className="tax">10%</td>
                        <td className="total">$ 2.02</td>
                      </tr>
                    </tbody>
                    <tfoot>
                      <tr>
                        <td colSpan="2"></td>
                        <td colSpan="2">SUBTOTAL</td>
                        <td>$ 6.95</td>
                      </tr>
                      <tr>
                        <td colSpan="2"></td>
                        <td colSpan="2">TAX 10%</td>
                        <td>$ 0.525</td>
                      </tr>
                      <tr>
                        <td colSpan="2"></td>
                        <td colSpan="2">GRAND TOTAL</td>
                        <td>$ 7.465</td>
                      </tr>
                    </tfoot>
	                </table>
	                <div className="thanks">Thank you!</div>
	                <div className="notices">
	                    <div>NOTICE:</div>
	                    <div className="notice">System Generated Invoice.</div>
	                </div>
		            </main>
		            <footer>
		                Invoice was generated on a computer and is valid without the signature and seal.
		            </footer>
			        </div>
			        <div></div>
				    </div>
					</div>
				</ModalBody>
			</Modal>
		)
	}
}

export default modalPlan;



// WEBPACK FOOTER //
// ./src/App/views/templates/dashboard/billing/ModalInvoice.js